import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    contextFieldSelect: {
        marginRight: '8px',
    },
}));
